import { userBaseFields, type UserBase } from './userBase';

export interface Audit {
  id: string;
  user: UserBase;
  action: string;
  objectType: string;
  objectId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  details: any;
  createdAt: string;
}

export const auditFields = `
  id
  user {
    ${userBaseFields}
  }
  action
  objectType
  objectId
  details
  createdAt
`;
